import React from "react";

import Authorize from "components/Library/Authorize/Authorize";
import Subscription from "subscriptions/components/Subscription";
import Subscriptions from "subscriptions/components/Subscriptions";
import NotFound from "components/Library/NotFound";
import SectionStream from "stream/containers/SectionStream";
import TagStream from "stream/containers/TagStream";
import PermalinkStream from "stream/containers/PermalinkStream";
import AuthorStream from "stream/containers/AuthorStream";
import SearchStream from "stream/containers/SearchStream";
import TopSectionStream from "stream/containers/TopSectionStream";
import EventsSectionStream from "stream/containers/EventsSectionStream";
import SmarterFasterSectionStream from "stream/containers/SmarterFasterSectionStream";
import MidtermsTagStream from "stream/containers/MidtermsTagStream";
import DeepDiveTagStream from "stream/containers/DeepDiveTagStream";
import deepDivesConfig from "config/deepDivesConfig";

import {
  getNewsletter,
  populateSubscription,
} from "subscriptions/actions/subscriptions";
import { getRedirectPath } from "utils/server";
import asyncComponent from "utils/asyncComponent";

import { URL_ID_REGEXP, SECTION, TAG } from "config/constants";

const oldPermalinkRoute = "/:slug([A-Za-z0-9-]+-)?:id([0-9]+).html";
const storyPermalinkRoute = `/:slug([A-Za-z0-9-]+?-)?:id${URL_ID_REGEXP}.html`;
const newsletterPermalinkRoute = `/newsletters/:subscription([A-Za-z0-9-]+?)-:newsletter${URL_ID_REGEXP}.html`;

const AsyncAbout = asyncComponent(() => import("about/components/About/About"));
const AsyncLegal = asyncComponent(() => import("legal/components/Legal/Legal"));

// TODO: Deep dives should be powered by an API, not hardcoded into a config file
const deepDiveRoutes = deepDivesConfig.map(deepDive => ({
  path: `/tag/:tag(${deepDive.slug})`,
  exact: true,
  render: () => <DeepDiveTagStream deepDive={deepDive} />,
}));

export const routes = [
  {
    path: "/",
    exact: true,
    component: TopSectionStream,
  },
  {
    path: "/authors/:username",
    exact: true,
    component: AuthorStream,
  },
  {
    path: "/results",
    exact: true,
    component: SearchStream,
  },
  {
    path: "/authorize",
    exact: true,
    component: Authorize,
  },
  {
    path: "/legal",
    exact: true,
    component: AsyncLegal,
  },
  {
    path: "/about",
    exact: true,
    component: AsyncAbout,
  },
  {
    path: "/events",
    exact: true,
    component: EventsSectionStream,
  },
  {
    path: `/:section(${SECTION.SMARTER_FASTER.slug})`,
    exact: true,
    component: SmarterFasterSectionStream,
  },
  {
    path: `/tag/:tag(${TAG.MIDTERM_ELECTIONS_2018.slug})`,
    exact: true,
    component: MidtermsTagStream,
  },
  ...deepDiveRoutes,
  {
    path: "/newsletters",
    exact: true,
    component: Subscriptions,
  },
  {
    path: newsletterPermalinkRoute,
    exact: true,
    component: Subscription,
    fetchData: (req, match, dispatch, context) =>
      Promise.all([
        getRedirectPath(req, match.params.newsletter, context),
        dispatch(getNewsletter(match.params.newsletter)),
        dispatch(populateSubscription(match.params.subscription)),
      ]),
  },
  {
    path: "/newsletters/:subscription",
    exact: true,
    component: Subscription,
    fetchData: (req, match, dispatch) =>
      dispatch(populateSubscription(match.params.subscription)),
  },
  {
    path: "/tag/:tag",
    exact: true,
    component: TagStream,
  },
  {
    path: storyPermalinkRoute,
    component: PermalinkStream,
    fetchData: (req, match, dispatch, context) => {
      if (req.query.preview || req.query.revision) return Promise.resolve();
      getRedirectPath(req, match.params.id, context);
    },
  },
  {
    path: oldPermalinkRoute,
    render: () => {
      null;
    },
    fetchData: (req, match, dispatch, context) =>
      getRedirectPath(req, match.params.id, context),
  },
  {
    path: "/community/:user",
    fetchData: (req, match, dispatch, context) => {
      context.status = 301;
      context.path = `/authors/${match.params.user}`;
      return Promise.resolve();
    },
  },
  {
    path: "/:section([a-zA-Z-]+)",
    render: props => {
      return <SectionStream {...props} />;
    },
    exact: true,
  },
  // 404 fallback route
  {
    path: "/*",
    render: ({ staticContext }) => {
      if (staticContext) staticContext.status = 404;
      return <NotFound />;
    },
  },
];
